module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie NavList is used to create list of navigation items inside a Nessie navigation bar, used inside Nessie NavBar and Nessie NavDropdown.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;NavList&gt;\n    &lt;NavItem isCurrentPage&gt;Home&lt;/NavItem&gt;\n    &lt;NavItem&gt;Somewhere else&lt;/NavItem&gt;\n&lt;/NavList&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/NavList/README.md
// module id = 367
// module chunks = 0